import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { CommomHeaders } from '@app/_shared/httpHeaders/CommonHeaders';
import {
    Page,
    ProductSearchFilter,
    SelectSearchFilter,
    TranslatePagePayload,
    TranslateSitePayload,
} from '@app/_models/pages/page.model';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class PagesService {
    constructor(private apiService: ApiService, private headers: CommomHeaders) {}

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json, text/javascript, */*; q=0.01',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: 'Bearer ' + sessionStorage.getItem('userData[token]'),
        }),
        withCredentials: true,
    };

    getPageList(idLang: number) {
        return this.apiService.getFz(`/api/v1/back/pages?language=${idLang}`, this.headers.getAuthHeaders());
    }
    getPage(idPage: number, langId: number) {
        return this.apiService.get(`/api/v1/back/pages/${idPage}`, { language: langId }, this.headers.getAuthHeaders());
    }

    createPage(page: any): Observable<any> {
        return this.apiService.postFz(`/api/v1/back/pages`, page, this.headers.getAuthHeaders());
    }
    createFolder(page: any): Observable<any> {
        return this.apiService.postFz(`/api/v1/back/pages/folder`, page, this.headers.getAuthHeaders());
    }

    createNewLink(link): Observable<any> {
        return this.apiService.postFz(`/api/v1/back/pages/link`, link, this.headers.getAuthHeaders());
    }
    updatePage(page) {
        return this.apiService.patch(`/api/v1/back/pages`, page, this.headers.getAuthHeaders());
    }
    deletePage(id: any, language: any) {
        return this.apiService.delete(
            `/api/v1/back/pages/${id}`,
            { language: language },
            this.headers.getAuthHeaders()
        );
    }

    getCategoriesForNewPage(): Observable<any> {
        return this.apiService.getFz(`/api/v1/back/pages/default/categories`, this.headers.getAuthHeaders());
    }

    duplicatePage(id: any, idLang: number) {
        return this.apiService.post(
            `/api/v1/back/pages/${id}/duplicate`,
            { language: idLang },
            this.headers.getAuthHeaders()
        );
    }

    reorderPages(pages: any, idLang: number) {
        return this.apiService.patch(
            `/api/v1/back/pages/reorder`,
            { language: idLang, pages: pages },
            this.headers.getAuthHeaders()
        );
    }

    updatePageField(page: Page) {
        return this.apiService.patch(`/api/v1/back/pages`, page, this.headers.getAuthHeaders());
    }

    getPosts(filter: SelectSearchFilter): Observable<any> {
        return this.apiService.postFz(`/api/v1/back/blog/posts/ShowList`, filter, this.headers.getAuthHeaders());
    }

    getBlogCategories(filter: SelectSearchFilter): Observable<any> {
        return this.apiService.postFz(`/api/v1/back/blog/categories/list`, filter, this.headers.getAuthHeaders());
    }

    getProducts(filter: ProductSearchFilter): Observable<any> {
        return this.apiService.postFz(
            `/api/v1/back/shop/v1/products/listing/listingproduct`,
            filter,
            this.headers.getAuthHeaders()
        );
    }

    getProductsCategories(): Observable<any> {
        return this.apiService.getFz(
            `/api/v1/back/shop/v1/categories/listing/listingcategory`,
            this.headers.getAuthHeaders()
        );
    }

    getSystemPageList(idLang: number) {
        return this.apiService.getFz(`/api/v1/back/pages/error-pages/${idLang}`, this.headers.getAuthHeaders());
    }

    getPredesignList(type: string, idLang: string): Observable<any> {
        const payload = {
            type_name: type,
            language_id: idLang,
        };
        return this.apiService.postFz(
            `/api/v1/back/pages/default/categories/error-pages`,
            payload,
            this.headers.getAuthHeaders()
        );
    }

    selectPredesign(page: any) {
        return this.apiService.getFz(
            `/api/v1/back/pages/edit-content/${page.idPage}/${page.idPredesign}/${page.countryCode}`,
            this.headers.getAuthHeaders()
        );
    }

    translatePage(payload: TranslatePagePayload) {
        return this.apiService.postFz(`/api/v1/back/translate/page`, payload, this.headers.getAuthHeaders());
    }

    translateSite(payload: TranslateSitePayload) {
        return this.apiService.postFz(`/api/v1/back/translate/site`, payload, this.headers.getAuthHeaders());
    }
}
